var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none",
    viewBox: "0 0 8 14",
    id: "svg12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.333 14a.686.686 0 01-.472-.186L.195 7.451a.618.618 0 010-.901L6.861.186a.692.692 0 01.944 0c.26.25.26.652 0 .901L1.61 7l6.195 5.913c.26.25.26.652 0 .901a.682.682 0 01-.472.186",
    clipRule: "evenodd",
    id: "path10",
    fillOpacity: 1
  })));
}
SvgPrevious.displayName = 'Previous';
export default SvgPrevious;